import React from 'react';
import {useBlocker, useNavigate} from 'react-router';

const useRouterBlocker = (isActive: boolean | (() => boolean)) => {
  const blocker = useBlocker(isActive);
  const navigate = useNavigate();
  const locationRef = React.useRef<string | null>(null);
  const isNavigateRef = React.useRef<boolean>(false);

  React.useEffect(() => {
    const handleBeforeUnload = (event: BeforeUnloadEvent) => {
      const isActiveFlag = typeof isActive === 'function' ? isActive() : isActive;

      if (!isActiveFlag) {
        return;
      }
      event.preventDefault();
      event.returnValue = '';
    };

    window.addEventListener('beforeunload', handleBeforeUnload);

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, [isActive]);

  const isBlocked = blocker.state === 'blocked';

  React.useEffect(() => {
    if (!isBlocked) {
      isNavigateRef.current = false;

      return;
    }

    locationRef.current = blocker.location?.pathname || null;

    if (isNavigateRef.current) {
      blocker.proceed();
      isNavigateRef.current = false;
    } else {
      blocker.reset();
    }
  }, [isBlocked]);

  const retryTransition = () => {
    if (locationRef.current) {
      isNavigateRef.current = true;
      navigate(locationRef.current);
    }
  };

  return {
    isBlocked: blocker.state === 'blocked' && !isNavigateRef.current,
    retryTransition,
  };
};

export {useRouterBlocker};
